// extracted by mini-css-extract-plugin
export default {"auth":"AuthForm_auth__461GW","control":"AuthForm_control__50uj5","actions":"AuthForm_actions__nZdbL","toggle":"AuthForm_toggle__vMD4v"};